/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable max-len */
/* eslint-disable no-param-reassign */
/* eslint-disable import/no-cycle */
/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable no-use-before-define */
/* eslint-disable no-case-declarations */
/* eslint-disable guard-for-in */
/* eslint-disable no-restricted-syntax */
/* eslint-disable no-plusplus */
/* eslint-disable no-unused-vars */
/* eslint-disable no-shadow */
/* eslint-disable no-nested-ternary */
/* eslint-disable camelcase */
import * as React from 'react';
import { useRef, useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { DialogUtility, DialogComponent } from '@syncfusion/ej2-react-popups';
import { TextBoxComponent } from '@syncfusion/ej2-react-inputs';
import { ButtonComponent } from '@syncfusion/ej2-react-buttons';
import { DropDownListComponent, MultiSelectComponent, CheckBoxSelection } from '@syncfusion/ej2-react-dropdowns';
import { KanbanComponent } from '@syncfusion/ej2-react-kanban';
import { Query } from '@syncfusion/ej2-data';
import { format, parseISO } from 'date-fns';
import { TabComponent, TabItemDirective, TabItemsDirective } from '@syncfusion/ej2-react-navigations';
import {
  GridComponent,
  Inject,
  ColumnsDirective,
  ColumnDirective,
  Page,
  Edit,
  Toolbar,
  ForeignKey,
} from '@syncfusion/ej2-react-grids';
import { useStateContext } from '../contexts/ContextProvider';
import { Heartbeat, Header, ReportCard } from '../components';
import { langData } from '../data/dummy';
import scribeHow from '../data/scribehow.png';

const Onboarding = () => {
  const alertDlg = useRef(null);
  const tab = useRef(null);
  const organizationGrid = useRef(null);
  const associateGrid = useRef(null);
  const managerGrid = useRef(null);
  const jobsGrid = useRef(null);
  const usersGrid = useRef(null);
  const journeyDate = useRef(null);
  const startPoint = useRef(null);
  const err_1 = useRef(null);
  const err_2 = useRef(null);
  const err_3 = useRef(null);
  let selectedOrganization;
  const [selectedAssociate, setSelectedAssociate] = useState([]);
  const [associates, setAssociates] = useState([]);
  const [bundles, setBundles] = useState([]);
  const [bandid, setBandId] = useState('');
  const [fetchJobs, setFetchJob] = useState(false);
  const [fetchUser, setFetchUser] = useState(false);
  const [fetchManager, setFetchManager] = useState(false);
  const [fetchAssociates, setFetchAssociates] = useState(false);
  const [fetchInventory, setFetchInventory] = useState(false);
  const [showOverlay, setShowOverlay] = useState(true);
  const [showGotItOrg, setShowGotItOrg] = useState(localStorage.getItem('gotItOrg'));
  const [showMgr, setShowMgr] = useState(false);
  const [showGotItMgr, setShowGotItMgr] = useState(localStorage.getItem('gotItMgr'));
  const [showAssociates, setShowAssociates] = useState(false);
  const [showGotItAssociates, setShowGotItAssociates] = useState(localStorage.getItem('gotItMgr'));
  const [showJobs, setShowJobs] = useState(false);
  const [showGotItJobs, setShowGotItJobs] = useState(localStorage.getItem('gotItJobs'));
  const [showUsers, setShowUsers] = useState(false);
  const [showGotItUsers, setShowGotItUsers] = useState(localStorage.getItem('gotItUsers'));

  let mgrRef;
  let mgrTemplateRef;
  const mgrfields = { text: 'name', value: '_id' };
  const [managers, setManagers] = useState([]);
  const [selNewTask, setNewTask] = useState('');
  const validRules = { required: true };

  const header = () => (
    <div><h1>Edit Task List</h1></div>
  );
  const [hideDialog, setDialog] = useState(true);
  const dropDownListObject = useRef(null);
  const removeTask = () => {
    const nt = document.getElementById('newtask').value;
    const orig = jobtasks.length;
    const updatedData = jobtasks.filter((item) => item.text !== nt);
    setJobTasks(updatedData);
    const myjobslist = [];
    updatedData.forEach((j) => {
      if (j.id !== '0') {
        myjobslist.push(j);
      }
      setJobTaskslist(myjobslist);
    });
    dropDownListObject.current.dataSource = updatedData;
    // dropdownInstance.dataBind();
    if (orig > updatedData.length) {
      dialogClick('na', 'Task Data', `Item ${nt} successfully removed, please remember to save your changes!`, null);
    }
  };

  const handleTaskChange = () => {
    const nt = document.getElementById('newtask').value;
    let rtn = false;
    if (jobtasks) {
      jobtasks.forEach((e, index) => {
        if (nt === e.text) {
          dialogClick('na', 'Task Data', `Item ${nt} already exists, please enter a unique task name!`, null);
          rtn = true;
        }
      });
    }
    if (rtn) {
      return;
    }
    const newItem = { id: nt.toLocaleLowerCase(), text: nt };
    if (nt === '') {
      dialogClick('na', 'Task Data', 'Please enter a unique task name!');
      return;
    }
    setJobTasks([...jobtasks, newItem]);
    setJobTaskslist([...jobtaskslist, newItem]);

    if (dropDownListObject && dropDownListObject.current) {
      dropDownListObject.current.addItem(newItem);
      dialogClick('na', 'Task Item added!', `${nt} has been added! Please remember to save your changes!`, null);
      document.getElementById('newtask').value = '';
    }
  };

  const taskTemplate = () => (
    <div className="m-2 md:m-4 mt-4 p-2 md:p-10 bg-white rounded-3xl">
      <div>
        <DropDownListComponent
          id="tasklist"
          dataSource={jobtasks}
          ref={dropDownListObject}
          sortOrder="Ascending"
          popupHeight="200px"
          value={jobtasks}
          enabled={crudAssociateUpdate}
          readonly={!crudAssociateUpdate}
          fields={{ text: 'text', value: 'id' }}
          placeholder="Task List"
          onChange={(v) => { document.getElementById('newtask').value = v.target.itemData.text; }}
        />
      </div>
      <div className="mt-4">
        <TextBoxComponent
          placeholder="Add new task"
          value=""
          width="250px"
          required
          id="newtask"
          showClearButton
          cssClass="e-outline"
          floatLabelType="Never"
          onChange={(v) => { if (v.value.length === 0) { setNewTask(''); } else { setNewTask(v.value); } }}
        />
      </div>
    </div>
  );
  const saveTaskList = () => {
    setDialog(!hideDialog);
    let org = null;
    if (!organizations) {
      return;
    }
    organizations.forEach((o, index) => {
      if (organizationid === o._id) {
        org = o;
      }
    });

    const array = [...jobtasks]; // make a separate copy of the array
    array.forEach((j, index) => {
      if (j.id === '0') {
        array.splice(index, 1);
        org.tasks = array;
      }
    });
    if (org) {
      fetch(`${REACT_APP_API_ENDPOINT}/organizations`, {
        method: 'UPDATE',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `JWTToken ${usr.token}`,
        },
        body: JSON.stringify(org),
      })
        .then((response) => response.json())
        .then((responseJson) => {
          // The added/edited data will be saved in the Grid
          if (responseJson && responseJson.response && responseJson.response !== 'OK') {
            dialogClick('na', 'Task save failed', `${responseJson.response}`, null);
            return;
          }
          setNewTask('');
          setLoading(!reload);
        })
        .catch((error) => {
          dialogClick('na', 'Task save error', `${error}`, null);
        });
    }
  };
  const addbuttons = [
    {
      // Click the footer buttons to hide the Dialog
      click: () => {
        removeTask();
      },
      // Accessing button component properties by buttonModel property
      buttonModel: {
        // Enables the primary button
        isPrimary: false,
        disabled: false,
        content: 'REMOVE',
      },
    },
    {
      // Click the footer buttons to hide the Dialog
      click: () => {
        handleTaskChange();
      },
      // Accessing button component properties by buttonModel property
      buttonModel: {
        // Enables the primary button
        isPrimary: false,
        content: 'ADD',
      },
    },
    {
      // Click the footer buttons to hide the Dialog
      click: () => {
        saveTaskList();
      },
      // Accessing button component properties by buttonModel property
      buttonModel: {
        // Enables the primary button
        isPrimary: false,
        content: 'SAVE',
      },
    },
    {
      // Click the footer buttons to hide the Dialog
      click: () => {
        setDialog(!hideDialog);
      },
      // Accessing button component properties by buttonModel property
      buttonModel: {
        // Enables the primary button
        isPrimary: true,
        content: 'CANCEL',
      },
    },
  ];

  const mgrGrid = (props) => (
    <div>
      <label htmlFor="managers">Select Manager:</label>
      <MultiSelectComponent
        id="managers"
        ref={(scope) => { mgrRef = scope; }}
        dataSource={managers}
        mode="CheckBox"
        fields={mgrfields}
        value={props.managers}
        enabled={crudAssociateUpdate}
        readonly={!crudAssociateUpdate}
      >
        <Inject services={[CheckBoxSelection]} />
      </MultiSelectComponent>
    </div>
  );
  const handleMgrChange = (args) => {
    if (args && args.value && args.value !== args.oldValue && associates) {
      associates.forEach((a, index) => {
        if (a._id === args.element.id && tab.current.selectedItem === 2) {
          associates[index].managers = args.value;
          fetch(`${REACT_APP_API_ENDPOINT}/associates`, {
            method: 'UPDATE',
            headers: {
              'Content-Type': 'application/json',
              Authorization: `JWTToken ${usr.token}`,
            },
            body: JSON.stringify(associates[index]),
          })
            .then((response) => response.json())
            .then((responseJson) => {
              // The added/edited data will be saved in the Grid
              if (responseJson && responseJson.response && responseJson.response !== 'OK') {
                dialogClick('na', 'Associate Manager Action', 'An error has occured during Update!', null);
              } else {
                dialogClick('na', 'Associate Manager Action', 'Updated!', null);
                setFetchAssociates(!fetchAssociates);
              }
            })
            .catch((error) => {
              dialogClick('na', 'Associate Manager Action', 'error!', null);
            });
        }
      });
    }
  };
  const mgrTemplateGrid = (props) => (
    <div>
      <MultiSelectComponent
        id="mgrid"
        ref={(scope) => { mgrTemplateRef = scope; }}
        dataSource={managers}
        mode="CheckBox"
        fields={mgrfields}
        value={props.managers}
        change={handleMgrChange}
        placeholder="Select Manager(s)"
        enabled={crudAssociateUpdate}
        readonly={!crudAssociateUpdate}
      >
        <Inject services={[CheckBoxSelection]} />
      </MultiSelectComponent>
    </div>
  );
  const bandGrid = (props) => (
    <div>
      <label htmlFor="device">Select Band:</label>
      <DropDownListComponent
        id="device"
        dataSource={armbands}
        enabled={crudAssociateUpdate}
        readonly={!crudAssociateUpdate}
        fields={{ value: 'device', text: 'bandId' }}
        // value={props.inventory && props.inventory.associateid ? props.inventory.associateid : '0 - Unassigned'}
        value={props.inventory && props.inventory.associateid ? props.inventory.associateid : '0 - Unassigned'}
      />
    </div>
  );
  const handleMSNChange = (args) => {
    if (args && args.itemData && associates && associates.length > 0) {
      const invAry = [];
      let thisassociate = null;
      if (!associates) {
        return;
      }
      associates.forEach((a, index) => {
        if (a.inventory && a.inventory.associateid && a.inventory.associateid === args.element.id && tab.current.selectedItem === 2) {
          if (args.value === '0') {
            associates[index].inventory.associateid = '';
            associates[index].inventory.associate = '';
          } else {
            associates[index].inventory.msn = args.itemData.msn;
            associates[index].inventory.bandId = args.itemData.bandId;
          }
          invAry.push(associates[index].inventory);
          thisassociate = associates[index];
        } else if (a._id === args.element.id) {
          // Initial Assignment of Inventory to Associate
          inventory.some((i, idx) => {
            if (i.msn === args.itemData.msn) {
              associates[index].inventory = inventory[idx];
              associates[index].inventory.associateid = args.element.id;
              associates[index].inventory.associate = associates[index].name;
              associates[index].device = i.device;
              invAry.push(associates[index].inventory);
              thisassociate = associates[index];
              thisassociate.device = inventory[idx].device;
              return true;
            }
            return false;
          });
        }
      });
      if (invAry.length === 1) {
        fetch(`${REACT_APP_API_ENDPOINT}/inventory`, {
          method: 'UPDATE',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `JWTToken ${usr.token}`,
          },
          body: JSON.stringify(invAry),
        })
          .then((response) => response.json())
          .then((responseJson) => {
            // The added/edited data will be saved in the Grid
            if (responseJson && responseJson.response && responseJson.response !== 'OK') {
              dialogClick('na', 'Inventory MSN Action', 'An error has occured during Update!', null);
            } else {
              dialogClick('na', 'Inventory MSN Action', 'Updated!', null);
              setFetchInventory(!fetchInventory);
            }
          })
          .catch((error) => {
            dialogClick('na', 'Inventory MSN Action', 'error!', null);
          });
      }
    }
  };
  const bandTemplateGrid = (props) => (
    <div>
      <DropDownListComponent
        id="armbandid"
        dataSource={armbands}
        fields={{ value: 'device', text: 'bandId' }}
        value={props.device || '0 - Unassigned'}
        change={handleMSNChange}
        sortOrder="Ascending"
        placeholder="Select ArmBand"
        enabled={crudAssociateUpdate}
        readonly={!crudAssociateUpdate}
      />
    </div>
  );
  const bundleGrid = (props) => (
    <div>
      <label htmlFor="alertBundle">Select Bundle:</label>
      <DropDownListComponent
        id="alertBundle"
        dataSource={bundles}
        fields={{ value: '_id', text: 'name' }}
        value={props.alertBundle}
        enabled={crudAssociateUpdate}
        readonly={!crudAssociateUpdate}
      />
    </div>
  );
  const handleBundleChange = (args) => {
    if (args && args.value && args.value !== args.oldValue && associates) {
      associates.forEach((a, index) => {
        if (a._id === args.element.id && tab.current.selectedItem === 2) {
          associates[index].alertBundle = args.value;
          fetch(`${REACT_APP_API_ENDPOINT}/associates`, {
            method: 'UPDATE',
            headers: {
              'Content-Type': 'application/json',
              Authorization: `JWTToken ${usr.token}`,
            },
            body: JSON.stringify(associates[index]),
          })
            .then((response) => response.json())
            .then((responseJson) => {
              // The added/edited data will be saved in the Grid
              if (responseJson && responseJson.response && responseJson.response !== 'OK') {
                dialogClick('na', 'Associate Bundle Action', 'An error has occured during Update!', null);
              } else {
                dialogClick('na', 'Associate Bundle Action', 'Updated!', null);
                setFetchAssociates(!fetchAssociates);
              }
            })
            .catch((error) => {
              dialogClick('na', 'Associate Bundle Action', 'error!', null);
            });
        }
      });
    }
  };
  const bundleTemplateGrid = (props) => (
    <div>
      <DropDownListComponent
        id="bundleid"
        dataSource={bundles}
        fields={{ value: '_id', text: 'name' }}
        value={props.alertBundle}
        change={handleBundleChange}
        placeholder="Select Bundle"
        enabled={crudAssociateUpdate}
        readonly={!crudAssociateUpdate}
      />
    </div>
  );
  const jobTaskGrid = (props) => (
    <div>
      <label htmlFor="jobtask">Select Job Task:</label>
      <DropDownListComponent
        id="jobtask"
        dataSource={jobtaskslist}
        fields={{ value: 'id', text: 'text' }}
        value={props.jobtask}
        enabled={crudAssociateUpdate}
        readonly={!crudAssociateUpdate}
      />
    </div>
  );
  const handleJobTaskChange = (args) => {
    if (args && args.value && args.value !== args.oldValue && associates) {
      associates.forEach((a, index) => {
        if (a._id === args.element.id && tab.current.selectedItem === 2) {
          associates[index].jobtask = args.value;
          fetch(`${REACT_APP_API_ENDPOINT}/associates`, {
            method: 'UPDATE',
            headers: {
              'Content-Type': 'application/json',
              Authorization: `JWTToken ${usr.token}`,
            },
            body: JSON.stringify(associates[index]),
          })
            .then((response) => response.json())
            .then((responseJson) => {
              // The added/edited data will be saved in the Grid
              if (responseJson && responseJson.response && responseJson.response !== 'OK') {
                dialogClick('na', 'Associate Job Task Action', 'An error has occured during Update!', null);
              } else {
                dialogClick('na', 'Associate Job Task Action', 'Updated!', null);
                setFetchAssociates(!fetchAssociates);
              }
            })
            .catch((error) => {
              dialogClick('na', 'Associate Job Task Action', 'error!', null);
            });
        }
      });
    }
  };
  const jobTaskTemplateGrid = (props) => (
    <div>
      <DropDownListComponent
        id="jobid"
        dataSource={jobtasks}
        fields={{ value: 'id', text: 'text' }}
        value={props.jobtask}
        enabled={crudAssociateUpdate}
        readonly={!crudAssociateUpdate}
        change={(e) => { if (e.value === '0') { setDialog(!hideDialog); } else { handleJobTaskChange(e); } }}
        placeholder="Select Job Task"
      />
    </div>
  );
  const langGrid = (props) => (
    <div>
      <label htmlFor="managers">Select Language:</label>
      <DropDownListComponent
        id="language"
        dataSource={langData}
        fields={{ value: 'id', text: 'value' }}
        value={props.language}
        placeholder="Language"
        enabled={crudMgrUpdate}
        readonly={!crudMgrUpdate}
      />
    </div>
  );
  const handleMgrLanguageChange = (args) => {
    if (args && args.value && args.value !== args.oldValue && managers) {
      managers.forEach((m, index) => {
        if (m._id === args.element.id && tab.current.selectedItem === 1) {
          managers[index].language = args.value;
          fetch(`${REACT_APP_API_ENDPOINT}/managers`, {
            method: 'UPDATE',
            headers: {
              'Content-Type': 'application/json',
              Authorization: `JWTToken ${usr.token}`,
            },
            body: JSON.stringify(managers[index]),
          })
            .then((response) => response.json())
            .then((responseJson) => {
              // The added/edited data will be saved in the Grid
              if (responseJson && responseJson.response && responseJson.response !== 'OK') {
                dialogClick('na', 'Manager Lanaguage Action', 'An error has occured during Update!', null);
              } else {
                dialogClick('na', 'Manager Lanaguage Action', 'Updated!', null);
                setFetchManager(!fetchManager);
              }
            })
            .catch((error) => {
              dialogClick('na', 'Manager Lanaguage Action', 'error!', null);
            });
        }
      });
    }
  };
  const handleLanguageChange = (args) => {
    if (args && args.value && args.value !== args.oldValue && associates) {
      associates.forEach((a, index) => {
        if (a._id === args.element.id && tab.current.selectedItem === 2) {
          associates[index].language = args.value;
          fetch(`${REACT_APP_API_ENDPOINT}/associates`, {
            method: 'UPDATE',
            headers: {
              'Content-Type': 'application/json',
              Authorization: `JWTToken ${usr.token}`,
            },
            body: JSON.stringify(associates[index]),
          })
            .then((response) => response.json())
            .then((responseJson) => {
              // The added/edited data will be saved in the Grid
              if (responseJson && responseJson.response && responseJson.response !== 'OK') {
                dialogClick('na', 'Associate Lanaguage Action', 'An error has occured during Update!', null);
              } else {
                dialogClick('na', 'Associate Lanaguage Action', 'Updated!', null);
                setFetchAssociates(!fetchAssociates);
              }
            })
            .catch((error) => {
              dialogClick('na', 'Associate Lanaguage Action', 'error!', null);
            });
        }
      });
    }
  };
  const langTemplateGrid = (props) => (
    <div>
      <DropDownListComponent
        id="langid"
        dataSource={langData}
        fields={{ value: 'id', text: 'value' }}
        value={props.language}
        change={handleLanguageChange}
        placeholder="Select Language"
        enabled={crudAssociateUpdate}
        readonly={!crudAssociateUpdate}
      />
    </div>
  );
  const langMgrTemplateGrid = (props) => (
    <div>
      <DropDownListComponent
        id="langmgrid"
        dataSource={langData}
        fields={{ value: 'id', text: 'value' }}
        value={props.language}
        change={handleMgrLanguageChange}
        placeholder="Select Language"
        enabled={crudMgrUpdate}
        readonly={!crudMgrUpdate}
      />
    </div>
  );
  let selectedJob;
  let selectedUser;
  let kanbanObj;
  let textBoxObj;
  const [risks, setRisk] = useState([]);

  const columnTemplate = (props) => (
    <div className="header-template-wrap">
      <div className={`header-icon e-icons ${props.keyField}`} />
      <div className="header-text">{props.headerText}</div>
      <div className="item-count">&nbsp;&nbsp;&nbsp;{props.count} items</div>
    </div>
  );
  function cardTemplate(props) {
    let brdr = '2px solid darkgrey';
    let bg = 'rgba(128, 128, 128, 0.5);'; /* 50% opaque grey background */

    switch (props.status) {
      case 'hypo':
        brdr = '2px solid 0251cc';
        bg = '#0251cc19';
        break;
      case 'baseline':
        brdr = '2px solid #19e14b';
        bg = '#19e14b19';
        break;
      case 'moderate':
        brdr = '2px solid #ecec11';
        bg = '#ecec1119';
        break;
      case 'elevated':
        brdr = '2px solid #ea9713';
        bg = '#ea971319';
        break;
      case 'severe':
        brdr = '2px solid #f30707';
        bg = '#f3070719';
        break;
      case 'nonreporting':
        brdr = '2px solid #ced1d6';
        bg = '#ced1d619';
        break;
      default:
        break;
    }
    let vitals = '';
    let vitalcnt = 1;
    if (props.associate) {
      // format(parseISO(data.associates[0].temperature.timestamp), 'MM/dd/yy hh:mm')}` : ''}</pre>
      if (props.associate.oxygen && props.associate.oxygen.reading) {
        vitals += `O₂: ${props.associate.oxygen.reading}% ${props.associate.oxygen.timestamp ? format(parseISO(props.associate.oxygen.timestamp), 'MM/dd hh:mm') : ''}\n`;
        vitalcnt++;
      }
      if (props.associate.temperature && props.associate.temperature.reading) {
        vitals += `CBT: ${props.associate.temperature.reading}°F ${props.associate.temperature.timestamp ? format(parseISO(props.associate.temperature.timestamp), 'MM/dd hh:mm') : ''}\n`;
        vitalcnt++;
      }
      if (props.associate.heartrate && props.associate.heartrate.reading) {
        vitals += `HR: ${props.associate.heartrate.reading}bpm ${props.associate.heartrate.timestamp ? format(parseISO(props.associate.heartrate.timestamp), 'MM/dd hh:mm') : ''}\n`;
        vitalcnt++;
      }
      if (props.associate.hrv && props.associate.hrv.reading) {
        vitals += `HRV: ${props.associate.hrv.reading}ms ${props.associate.hrv.timestamp ? format(parseISO(props.associate.hrv.timestamp), 'MM/dd hh:mm') : ''}\n`;
        vitalcnt++;
      }
      if (props.associate.hydration && props.associate.hydration.reading) {
        vitals += `Hyd: ${props.associate.hydration.reading}% ${props.associate.hydration.timestamp ? format(parseISO(props.associate.hydration.timestamp), 'MM/dd hh:mm') : ''}\n`;
        vitalcnt++;
      }
      if (props.associate.fatigue && props.associate.fatigue.reading) {
        vitals += `Exr: ${props.associate.fatigue.reading} ${props.associate.fatigue.timestamp ? format(parseISO(props.associate.fatigue.timestamp), 'MM/dd hh:mm') : ''}\n`;
        vitalcnt++;
      }
      if (props.associate.bloodpressure && props.associate.bloodpressure.reading) {
        vitals += `BP: ${props.associate.bloodpressure.reading}sys/dia ${props.associate.bloodpressure.timestamp ? format(parseISO(props.associate.bloodpressure.timestamp), 'MM/dd hh:mm') : ''}\n`;
        vitalcnt++;
      }
      if (props.associate.respiratory && props.associate.respiratory.reading) {
        vitals += `RR: ${props.associate.respiratory.reading}bpm ${props.associate.respiratory.timestamp ? format(parseISO(props.associate.respiratory.timestamp), 'MM/dd hh:mm') : ''}\n`;
        vitalcnt++;
      }
      if (props.associate.h2s && props.associate.h2s.reading) {
        vitals += `H₂S: ${props.associate.h2s.reading}ppm ${props.associate.h2s.timestamp ? format(parseISO(props.associate.h2s.timestamp), 'MM/dd hh:mm') : ''}\n`;
        vitalcnt++;
      }
    }
    vitals = vitals.trim();
    const htmlAttributes = { rows: vitalcnt };
    return (
      <div className="card-template" style={{ height: '240px', marginBottom: '2' }}>
        <div
          style={{
            border: brdr,
            position: 'absolute',
            backgroundColor: bg,
            zIndex: 1,
            top: 2,
            marginBottom: 'auto',
            width: 'auto', // or you can use width: '100vw'
            height: 'auto', // or you can use height: '100vh'
          }}
          className="e-card-content e-card-separator"
        >
          {Object.hasOwn(props, 'associate') && (
            <TextBoxComponent
              value={`${props.associate.name} Risk: ${props.associate.risk}`}
              readOnly
              cssClass="e-small"
            />
          )}
          {Object.hasOwn(props, 'associate') && vitals && (
            <TextBoxComponent
              value={vitals}
              multiline
              htmlAttributes={htmlAttributes}
              readOnly
              cssClass="e-small"
            />
          )}
          {Object.hasOwn(props, 'associate') && props.associate.inventory && props.associate.inventory.msn && (
            <TextBoxComponent
              value={`MSN: ${props.associate.inventory.msn} Battery: ${props.associate.inventory.battery}%`}
              readOnly
              cssClass="e-small"
            />
          )}
          {Object.hasOwn(props, 'associate') && props.associate.device && (
            <TextBoxComponent
              value={props.associate.device}
              readOnly
              cssClass="e-small"
            />
          )}
        </div>
      </div>
    );
  }
  const {
    zRenderMode,
    isMobile,
  } = useStateContext();
  const orgDataBound = (args) => {
    if (organizationGrid && organizationGrid.current && organizations) {
      organizations.forEach((org, index) => {
        if (org._id === organizationid || organizations.length === 1) {
          organizationGrid.current.selectRow(index, true);
        }
      });
    }
  };
  const dlgTarget = document.querySelector(
    '.sb-content-tab.e-tab .e-content.sb-sample-content-area',
  );
  const fields = { id: 'id', text: 'text', value: 'text' };
  const autoCompleteFields = { text: 'title', value: '_id' };

  const headerText = [
    { text: 'Organization' },
    { text: 'Manager List' },
    { text: 'Associate List' },
    { text: 'Jobs' },
    { text: 'Users' },
    { text: 'Triage' },
    { text: 'Charts' },
  ];

  const quotas = [
    { id: '1', text: 'Business Class' },
    { id: '2', text: 'Economy Class' },
    { id: '4', text: 'Common Class' },
  ];

  const gender = [{ id: '1', text: 'Male' }, { id: '2', text: 'Female' }];

  const berths = [
    { id: '1', text: 'Upper' },
    { id: '2', text: 'Lower' },
    { id: '3', text: 'Middle' },
    { id: '4', text: 'Window' },
    { id: '5', text: 'Aisle' },
  ];
  const navigate = useNavigate();
  let usr = localStorage.getItem('user');
  let selectedOrg = localStorage.getItem('organization');
  if (!usr || !selectedOrg) {
    // Redirect
    navigate('/login?landing=onboarding');
    return <p>Please login... </p>;
  }
  usr = JSON.parse(usr);
  selectedOrg = JSON.parse(selectedOrg);
  const { REACT_APP_API_ENDPOINT } = process.env;
  const [reload, setLoading] = useState(true);
  const [enableContent, setEnableContent] = useState(true);
  const [organizations, setOrganizations] = useState([]);
  const [neworg, setNewOrg] = useState('');
  const [newlocation, setNewLocation] = useState('');
  const [newaddress, setNewAddress] = useState('');
  const [newcity, setNewCity] = useState('');
  const [newstate, setNewState] = useState('');
  const [newzip, setNewZip] = useState('');
  const [data, setData] = useState([]);
  const [organization, setOrganization] = useState('');
  const [organizationid, setOrganizationId] = useState('');
  const [jobtasks, setJobTasks] = useState([]);
  const [jobtaskslist, setJobTaskslist] = useState([]);
  const [inventory, setInventory] = useState([]);
  const [armbands, setArmBands] = useState([]);
  const [jobs, setJobs] = useState([]);
  const [users, setUsers] = useState([]);
  const [roles, setRoles] = useState([]);
  const statuses = [
    { id: 'active', text: 'Active' },
    { id: 'completed', text: 'Completed' },
    { id: 'unscheduled', text: 'Unscheduled' },
    { id: 'inactive', text: 'InActive' },

  ];
  useEffect(() => {
    // limit associates to the overall selection
    if (usr.organizationid === '') {
      return;
    }
    // fetch data
    const dataFetch = async () => {
      const query = Object.entries(usr)
        .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
        .join('&');
      const url = `${REACT_APP_API_ENDPOINT}/organizations?${query}`;
      const mydata = await (
        await fetch(url, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `JWTToken ${usr.token}`,
          },
        })
      ).json()
        .catch((err) => {
          console.error('Error parsing JSON:', err);
          return null;
        });
      // set state when the data received
      setOrganizations(mydata.organization);
      setData(mydata);
      setLoading(false);
    };
    dataFetch();
  }, [reload]);

  useEffect(() => {
    if (organizationid.length > 0) {
      usr.organizationid = organizationid;
    } else {
      return;
    }

    const getJobsData = async () => {
      const query = Object.entries(usr)
        .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
        .join('&');
      const url = `${REACT_APP_API_ENDPOINT}/organizations?${query}&orgid=${usr.organizationid}`;
      await fetch(url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `JWTToken ${usr.token}`,
        },
      })
        .then((response) => response.json())
        .then((mydata) => {
          let myjobs = [];
          const myjobslist = [];
          if (mydata && mydata.tasks && mydata.tasks.length > 0) {
            myjobs = mydata.tasks;
            mydata.tasks.forEach((j) => {
              myjobslist.push(j);
            });
          }
          setJobTaskslist(myjobslist);
          myjobs.push({ id: '0', text: 'Add/Remove JobTask' });
          setJobTasks(myjobs);
        })
        .catch((error) => {
          setJobTasks([]);
        });
    };
    getJobsData();
  }, [inventory]);

  useEffect(() => {
    // limit associates to the overall selection
    if (organizationid.length > 0) {
      usr.organizationid = organizationid;
    } else {
      return;
    }
    // fetch data
    const dataFetch = async () => {
      usr.specific = 'true';
      const query = Object.entries(usr)
        .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
        .join('&');
      const url = `${REACT_APP_API_ENDPOINT}/associates?${query}`;
      if (!usr.loggedIn) {
        navigate('/login');
        return;
      }
      const mydata = await (
        await fetch(url, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `JWTToken ${usr.token}`,
          },
        })
      ).json()
        .catch((err) => {
          console.error('Error parsing JSON:', err);
          return null;
        });
      const riskData = [];
      if (mydata && mydata.associates) {
        mydata.associates.forEach((associate, index) => {
          if (!associate.risk || associate.risk === '' || !associate.name || associate.nmae === '') {
            const nonreporting = { status: 'nonreporting', organizationid: associate.organizationid, organization: associate.organization, associate };
            riskData.push(nonreporting);
          } else if (associate.risk < 0) {
            const hypo = { status: 'hypo', organizationid: associate.organizationid, organization: associate.organization, associate };
            riskData.push(hypo);
          } else if (associate.risk < 25) {
            const baseline = { status: 'baseline', organizationid: associate.organizationid, organization: associate.organization, associate };
            riskData.push(baseline);
          } else if (associate.risk < 50) {
            const moderate = { status: 'moderate', organizationid: associate.organizationid, organization: associate.organization, associate };
            riskData.push(moderate);
          } else if (associate.risk < 80) {
            const elevated = { status: 'elevated', organizationid: associate.organizationid, organization: associate.organization, associate };
            riskData.push(elevated);
          } else {
            const severe = { status: 'severe', organizationid: associate.organizationid, organization: associate.organization, associate };
            riskData.push(severe);
          }
        });
      }
      const sortedByRisk = [...riskData].sort((a, b) => Number(a.associate.risk) - Number(b.associate.risk));

      setRisk(sortedByRisk);
      setData(mydata);
      // setManagers(mydata.managers || []);
      setAssociates(mydata.associates);
    };
    dataFetch();
  }, [fetchAssociates]);
  useEffect(() => {
    usr.organizationid = organizationid;
    // fetch data
    const dataFetch = async () => {
      usr.specific = 'true';
      const query = Object.entries(usr)
        .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
        .join('&');
      const url = `${REACT_APP_API_ENDPOINT}/inventory?${query}`;
      const mydata = await (
        await fetch(url, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `JWTToken ${usr.token}`,
          },
        })
      ).json()
        .catch((err) => {
          console.error('Error parsing JSON:', err);
          return null;
        });
      const bands = [];
      bands.push({ device: '0', msn: '0 - Unassigned', bandId: '0 - Unassigned' });
      if (mydata && mydata.inventory) {
        mydata.inventory.forEach((i) => {
          if (i.bandId && i.bandId.length > 0) {
            bands.push({ device: i.device, msn: `${i.msn}`, bandId: `${i.bandId}` });
          } else if (i.msn && i.msn.length > 0) {
            bands.push({ device: i.device, msn: `${i.msn}`, bandId: `${i.msn}` });
          }
        });
        setInventory(mydata.inventory);
        setArmBands(bands);
        if (associates && associates.length > 0) {
          associates.forEach((assoc) => {
            if (assoc._id) { // Ensure 'data' property exists and is an array
              mydata.inventory.forEach((inv) => {
                if (assoc._id === inv.associateid) {
                  assoc.inventory = inv;
                }
              });
            }
          });
        }
      } else {
        setInventory([]);
        setArmBands([]);
      }
      // set state when the data received
      // setData(mydata);
      setLoading(false);
    };
    dataFetch();
  }, [associates, fetchInventory]);
  useEffect(() => {
    // limit associates to the overall selection
    usr.organizationid = organizationid;
    // usr.organization = organization;
    // fetch data
    const dataFetch = async () => {
      try {
        const query = Object.entries(usr)
          .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
          .join('&');
        const url = `${REACT_APP_API_ENDPOINT}/jobs?${query}`;
        const mydata = await (
          await fetch(url, {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              Authorization: `JWTToken ${usr.token}`,
            },
          })
        ).json()
          .catch((err) => {
            console.error('Error parsing JSON:', err);
            return null;
          });
        setJobs(mydata.jobs);
      } catch (err) {
        setJobs([]);
      }
    };
    // set state when the data received
    dataFetch();
  }, [fetchJobs]);
  useEffect(() => {
    // limit associates to the overall selection
    usr.organizationid = organizationid;

    // fetch data
    const dataFetch = async () => {
      const query = Object.entries(usr)
        .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
        .join('&');
      const url = `${REACT_APP_API_ENDPOINT}/users?${query}`;
      const mydata = await (
        await fetch(url, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `JWTToken ${usr.token}`,
          },
        })
      ).json()
        .catch((err) => {
          console.error('Error parsing JSON:', err);
          return null;
        });
      if (mydata.users) {
        // set state when the data received
        setUsers(mydata.users);
        setRoles(mydata.roles);
      } else {
        setUsers([]);
      }
    };
    dataFetch();
  }, [fetchUser]);

  useEffect(() => {
    const getManagerData = async () => {
      if (organizationid === '') {
        return;
      }
      usr.specific = 'true';
      const query = Object.entries(usr)
        .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
        .join('&');
      const url = `${REACT_APP_API_ENDPOINT}/managers?${query}&orgid=${organizationid}`;
      await fetch(url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `JWTToken ${usr.token}`,
        },
      })
        .then((response) => response.json())
        .then((mydata) => {
          if (mydata && mydata.managers && mydata.managers.length > 0) {
            mydata.managers.forEach((m) => {
              m.name = `${m.first} ${m.last}`;
            });
            setManagers(mydata.managers);
          } else if (mydata && mydata.length > 0) {
            mydata.forEach((m) => {
              m.name = `${m.first} ${m.last}`;
            });
            setManagers(mydata);
          } else {
            setManagers([]);
          }
        })
        .catch((e) => {
          DialogUtility.alert(`Error fetching managers: ${e}`);
          setManagers([]);
        });
    };
    getManagerData();
  }, [fetchManager]);

  useEffect(() => {
    usr.organizationid = organizationid;
    // fetch data
    const dataFetch = async () => {
      const query = Object.entries(usr)
        .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
        .join('&');
      const url = `${REACT_APP_API_ENDPOINT}/alerts?${query}`;
      const mydata = await (
        await fetch(url, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `JWTToken ${usr.token}`,
          },
        })
      ).json()
        .catch((err) => {
          console.error('Error parsing JSON:', err);
          return null;
        });
      // set state when the data received
      const bns = [];
      if (associates && associates.length > 0) {
        if (mydata && mydata.alerts) {
          mydata.alerts.forEach((alert) => {
            if (alert.organizationid === organizationid) {
              bns.push({ _id: alert._id, name: alert.name });
            }
          });
        }
        bns.push({ _id: '0', name: 'System Default' });
        setBundles(bns);
      } else {
        bns.push({ _id: '0', name: 'System Default' });
        setBundles(bns);
      }
    };
    dataFetch();
  }, [associates]);

  const dlgButtons = [
    {
      buttonModel: { content: 'OK', isPrimary: true },
      // tslint:disable-next-line: no-empty
      click: () => {
        alertDlg.current.hide();
        tab.current.enableTab(0, true);
        tab.current.enableTab(1, false);
        tab.current.enableTab(2, false);
        tab.current.enableTab(3, false);
        tab.current.enableTab(4, false);
        tab.current.select(0);
        if (data && data.user && data.user._id) {
          data.user.onboard = false;
          if (data.user.lastLogin && data.user.lastLogin === '') {
            data.user.lastLogin = '1970-01-01T00:00:00.000Z';
          }
          // Here you can send the updated data to your server using AJAX call
          fetch(`${REACT_APP_API_ENDPOINT}/users`, {
            method: 'UPDATE',
            headers: {
              'Content-Type': 'application/json',
              Authorization: `JWTToken ${usr.token}`,
            },
            body: JSON.stringify(data.user),
          })
            .then((response) => response.json())
            .then(() => {
              // The added/edited data will be saved in the Grid
              // The default edit operation is cancelled
              window.location.reload();
            })
            .catch(() => {
              dialogClick('na', 'User Action', 'An error has occured during Onboarding Update!', null);
            });
        }
      },
    },
  ];

  const dlgCreated = () => {
    alertDlg.current.hide();
  };

  const focusIn = () => {
    journeyDate.current.show();
  };

  const tabSelected = (e) => {
    if (e.isSwiped) {
      e.cancel = true;
    }
  };
  const organizationSelected = (args) => {
    selectedOrganization = args.data;
    if (startPoint && startPoint.current) {
      startPoint.current.value = args.data._id;
      // RWH setManagers([]);
      setOrganizationId(args.data._id);
      setOrganization(args.data.title);
    }
  };

  const associateSelected = (args) => {
    // setSelectedAssociate(args.data);
    // setEnableContent(false);
  };
  const managerSelected = (args) => {

  };
  const jobSelected = (args) => {
    selectedJob = args.data;
  };
  const userSelected = (args) => {
    selectedUser = args.data;
  };

  const btnClicked = (e) => {
    if (!startPoint || !startPoint.current) {
      return;
    }
    switch (e.target.id) {
      case 'searchNext':
        /* Validate the Source, Destination, Date and Class chosen and proceed only if all the fields are selected */
        if (
          startPoint.current.value != null
        ) {
          if (
            !startPoint.current.value
          ) {
            err_1.current.innerText = '* Parent Organization not selected';
          } else {
            setFetchManager(!fetchManager);
            setShowMgr(true);
            tab.current.enableTab(0, false);
            tab.current.enableTab(1, true);
            tab.current.select(1);
            err_1.current.innerText = '';
            if (err_2.current) {
              err_2.current.innerText = '';
            }
          }
        } else {
          err_1.current.innerText = '* Please fill all the details before proceeding';
        }
        break;
      case 'associateNext':
        /* Validate the Source, Destination, Date and Class chosen and proceed only if all the fields are selected */
        if (
          startPoint.current.value != null
        ) {
          if (
            !startPoint.current.value
          ) {
            err_1.current.innerText = '* Parent Organization not selected';
          } else {
            setFetchManager(!fetchManager);
            setShowAssociates(true);
            setFetchAssociates(!fetchAssociates); // Try refreshing the associates
            tab.current.enableTab(1, false);
            tab.current.enableTab(2, true);
            tab.current.select(2);
            err_1.current.innerText = '';
            if (err_2.current) {
              err_2.current.innerText = '';
            }
          }
        } else {
          err_1.current.innerText = '* Please fill all the details before proceeding';
        }
        break;
      case 'addJobs':
        /* Based on the selected station generate Grid content to display trains available */
        if (
          organizationid.length === 0
        ) {
          err_2.current.innerText = '* Select an Organization';
        } else {
          setFetchJob(!fetchJobs);
          setShowJobs(true);
          tab.current.enableTab(3, true);
          tab.current.select(3);
          tab.current.enableTab(2, false);
          err_2.current.innerText = '';
        }
        break;
      case 'addUsers':
        if (organizationid.length === 0) {
          err_3.current.innerText = '* Please enter passenger details';
        } else {
          setFetchUser(!fetchUser);
          setShowUsers(true);
          tab.current.enableTab(4, true);
          tab.current.select(4);
          tab.current.enableTab(3, false);
          err_3.current.innerText = '';
        }
        break;
      case 'makePayment':
        alertDlg.current.show();
        break;
      case 'goToManagers':
        /* Go back to change */
        setFetchManager(!fetchManager);
        setShowMgr(true);
        tab.current.enableTab(0, true);
        tab.current.select(0);
        tab.current.enableTab(1, false);
        break;
      case 'goBackToAssociates':
        /* Change the  */
        setFetchAssociates(!fetchAssociates);
        setShowAssociates(true);
        tab.current.enableTab(2, true);
        tab.current.select(2);
        tab.current.enableTab(3, false);
        break;
      case 'goBackToJobs':
        /* Update Jobs */
        setShowJobs(true);
        tab.current.enableTab(3, true);
        tab.current.select(3);
        tab.current.enableTab(4, false);
        break;
      default:
        break;
    }
  };

  let dialogInstance;
  function dialogClick(f, hdr, content, e) {
    const ok = null;
    dialogInstance = DialogUtility.confirm({
      title: hdr,
      content,
      okButton: ok,
      cancelButton: { text: 'Cancel', click: () => { dialogInstance.hide(); } },
      showCloseIcon: true,
      closeOnEscape: true,
      isModal: true,
      animationSettings: { effect: 'Zoom' },
    });
  }
  const toolbarOptions = ['Add', 'Edit', 'Delete', 'Search'];
  const editOptions = {
    allowEditing: true,
    allowAdding: true,
    allowDeleting: true,
    showConfirmDialog: true,
    showDeleteConfirmDialog: true,
    allowEditOnDblClick: false,
    mode: 'Normal',
  };
  const orgActionComplete = (args) => {
    if (args.requestType === 'beginEdit') {
      // eslint-disable-next-line prefer-destructuring
      const dialog = args.dialog;
      if (dialog) {
        dialog.width = '50vw';
        dialog.header = `Details for: ${args.rowData.title}`;
        // Customize the footer buttons
        dialog.buttons = [
          {
            buttonModel: { content: 'Save', cssClass: 'e-primary e-custom-save-button' },
            click: () => {
              // Implement your custom save logic here
              // For example, trigger the default update action:
              organizationGrid.current.endEdit();
              dialog.hide(); // Hide the dialog after saving
            },
          },
          {
            buttonModel: { content: 'Cancel', cssClass: 'e-danger' },
            click: () => {
              organizationGrid.current.closeEdit(); // Cancel the edit operation
              dialog.hide();
            },
          },
        ];

        // Mobile-specific adjustments (example)
        if (isMobile) { // Assuming 768px as a breakpoint for mobile
          dialog.width = '90%'; // Make dialog wider on mobile
          // Further adjust button styles if needed using CSS classes
        }
      }
    }
    if (args.requestType === 'save' && args.form && args.action === 'add') {
      if (args && args.data && args.data.title.length > 0) {
        if (!organizationid || organizationid.length === 0) {
          args.cancel = true;
          DialogUtility.alert('No Parent Organization');
          setLoading(!reload);
          return;
        }
        // The default edit operation is cancelled
        // Here you can send the updated data to your server using AJAX call
        if (args.data.parent) {
          args.data.parent._id = organizationid;
          args.data.parent.name = organization;
        } else {
          // Create the parent object
          args.data.parent = { _id: organizationid, name: organization };
        }

        fetch(`${REACT_APP_API_ENDPOINT}/organizations`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `JWTToken ${usr.token}`,
          },
          body: JSON.stringify(args.data),
        })
          .then((response) => response.json())
          .then((responseJson) => {
            // The added/edited data will be saved in the Grid
            if (responseJson && responseJson._id) {
              args.data._id = responseJson._id;
            }
            if (responseJson && responseJson.response && responseJson.response !== 'OK') {
              dialogClick('na', 'Organization Action', 'An error has occured during Insert!', null);
              args.cancel = true;
              setLoading(!reload);
            } else {
              dialogClick('na', 'Organization Action', 'Added!', null);
            }
          })
          .catch(() => {
            dialogClick('na', 'Organization Action', 'error!', null);
            args.cancel = true;
            setLoading(!reload);
          });
      }
    } else if (args.requestType === 'save' && args.form && args.action === 'edit') {
      if (args.data) {
        // Here you can send the updated data to your server using AJAX call
        args.data.organizationid = organizationid;
        args.data.organization = organization;
        fetch(`${REACT_APP_API_ENDPOINT}/organizations`, {
          method: 'UPDATE',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `JWTToken ${usr.token}`,
          },
          body: JSON.stringify(args.data),
        })
          .then((response) => response.json())
          .then(() => {
            // The added/edited data will be saved in the Grid
            // The default edit operation is cancelled
          })
          .catch(() => {
            dialogClick('na', 'Organization Action', 'An error has occured during Update!', null);
            args.cancel = true;
            setLoading(!reload);
          });
      }
    } else if (args.requestType === 'delete') {
      let entry = ' this entry?';
      if (args.data.length > 1) {
        entry = ' these entries?';
      }
      if (args.data) {
        // Here you can send the updated data to your server using AJAX call
        fetch(`${REACT_APP_API_ENDPOINT}/organizations`, {
          method: 'DELETE',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `JWTToken ${usr.token}`,
          },
          body: JSON.stringify(args.data),
        })
          .then((response) => response.json())
          .then(() => {
            // The added/edited data will be saved in the Grid
            // The default edit operation is cancelled
            dialogClick('na', 'Organization Action', 'Removed!', null);
          })
          .catch(() => {
            dialogClick('na', 'Organization Action', 'An error has occured during Removal!', null);
            args.cancel = true;
            setLoading(!reload);
          });
      }
    }
  };
  const managerActionComplete = (args) => {
    if (args.requestType === 'beginEdit') {
      // eslint-disable-next-line prefer-destructuring
      const dialog = args.dialog;
      if (dialog) {
        dialog.width = '50vw';
        dialog.header = `Details for: ${args.rowData.name}`;
        // Customize the footer buttons
        dialog.buttons = [
          {
            buttonModel: { content: 'Save', cssClass: 'e-primary e-custom-save-button' },
            click: () => {
              // Implement your custom save logic here
              // For example, trigger the default update action:
              managerGrid.current.endEdit();
              dialog.hide(); // Hide the dialog after saving
            },
          },
          {
            buttonModel: { content: 'Cancel', cssClass: 'e-danger' },
            click: () => {
              managerGrid.current.closeEdit(); // Cancel the edit operation
              dialog.hide();
            },
          },
        ];

        // Mobile-specific adjustments (example)
        if (isMobile) { // Assuming 768px as a breakpoint for mobile
          dialog.width = '90%'; // Make dialog wider on mobile
          // Further adjust button styles if needed using CSS classes
        }
      }
    }
    if (args.requestType === 'save' && args.form && args.action === 'add') {
      if (args && args.data && args.data.first.length > 0) {
        // The default edit operation is cancelled
        // Here you can send the updated data to your server using AJAX call
        if (!args.data.organizationid || args.data.organizationid.length === 0) {
          args.data.organizationid = organizationid;
          args.data.organization = organization;
        }
        fetch(`${REACT_APP_API_ENDPOINT}/managers`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `JWTToken ${usr.token}`,
          },
          body: JSON.stringify(args.data),
        })
          .then((response) => response.json())
          .then((responseJson) => {
            // The added/edited data will be saved in the Grid
            if (responseJson && responseJson._id) {
              args.data._id = responseJson._id;
            }
            if (responseJson && responseJson.response && responseJson.response !== 'OK') {
              dialogClick('na', 'Manager Action', 'An error has occured during Insert!', null);
              args.cancel = true;
            } else {
              dialogClick('na', 'Manager Action', 'Added!', null);
            }
          })
          .catch((error) => {
            dialogClick('na', 'Manager Action', 'error!', null);
            args.cancel = true;
          });
      }
    } else if (args.requestType === 'save' && args.form && args.action === 'edit') {
      if (args.data) {
        // Here you can send the updated data to your server using AJAX call
        args.data.organizationid = organizationid;
        args.data.organization = organization;
        fetch(`${REACT_APP_API_ENDPOINT}/managers`, {
          method: 'UPDATE',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `JWTToken ${usr.token}`,
          },
          body: JSON.stringify(args.data),
        })
          .then((response) => response.json())
          .then(() => {
            // The added/edited data will be saved in the Grid
            // The default edit operation is cancelled
            dialogClick('na', 'Manager Action', 'Updated!', null);
            setFetchManager(!fetchManager);
          })
          .catch(() => {
            dialogClick('na', 'Manager Action', 'An error has occured during Update!', null);
            args.cancel = true;
          });
      }
    } else if (args.requestType === 'delete') {
      if (args.data) {
        // Here you can send the updated data to your server using AJAX call
        fetch(`${REACT_APP_API_ENDPOINT}/managers`, {
          method: 'DELETE',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `JWTToken ${usr.token}`,
          },
          body: JSON.stringify(args.data),
        })
          .then((response) => response.json())
          .then(() => {
            // The added/edited data will be saved in the Grid
            // The default edit operation is cancelled
            dialogClick('na', 'Manager Action', 'Removed!', null);
            setFetchManager(!fetchManager);
          })
          .catch(() => {
            dialogClick('na', 'Manager Action', 'An error has occured during Removal!', null);
            args.cancel = true;
          });
      }
    }
  };
  const assocActionComplete = (args) => {
    /** Set initial Focus */
    if (args.requestType === 'beginEdit') {
      args.form.elements.namedItem('name').focus();
      // eslint-disable-next-line prefer-destructuring
      const dialog = args.dialog;
      if (dialog) {
        dialog.header = `Details of ${args.rowData.name}`;
        // Customize the footer buttons
        dialog.buttons = [
          {
            buttonModel: { content: 'Save', cssClass: 'e-primary e-custom-save-button' },
            click: () => {
              // Implement your custom save logic here
              // For example, trigger the default update action:
              associateGrid.current.endEdit();
              dialog.hide(); // Hide the dialog after saving
            },
          },
          {
            buttonModel: { content: 'Cancel', cssClass: 'e-danger' },
            click: () => {
              associateGrid.current.closeEdit(); // Cancel the edit operation
              dialog.hide();
            },
          },
        ];

        // Mobile-specific adjustments (example)
        if (isMobile) { // Assuming 768px as a breakpoint for mobile
          dialog.width = '90%'; // Make dialog wider on mobile
          // Further adjust button styles if needed using CSS classes
        }
      }
    }
    if (args.requestType === 'save' && args.form && args.action === 'add') {
      if (args && args.data && args.data.name.length > 0) {
        // The default edit operation is cancelled
        // Here you can send the updated data to your server using AJAX call
        if (!args.data.organizationid || args.data.organizationid.length === 0) {
          args.data.organizationid = organizationid;
        }
        const oresult = organizations.find(({ _id }) => _id === args.data.organizationid);
        if (oresult) {
          args.data.organization = oresult.title;
        }
        fetch(`${REACT_APP_API_ENDPOINT}/associates`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `JWTToken ${usr.token}`,
          },
          body: JSON.stringify(args.data),
        })
          .then((response) => response.json())
          .then((responseJson) => {
            // The added/edited data will be saved in the Grid
            if (responseJson && responseJson._id) {
              args.data._id = responseJson._id;
            }
            if (responseJson && responseJson.response && responseJson.response !== 'OK') {
              dialogClick('na', 'Associate Action error', 'An error has occured during Insert!', null);
              args.cancel = true;
            } else {
              setFetchAssociates(!fetchAssociates);
              dialogClick('na', 'Associate Action', 'Added!', null);
            }
          })
          .catch((error) => {
            dialogClick('na', 'Associate Action', 'error!', null);
            args.cancel = true;
          });
      }
    } else if (args.requestType === 'save' && args.form && args.action === 'edit') {
      if (args.data) {
        // Here you can send the updated data to your server using AJAX call
        args.data.organizationid = organizationid;
        args.data.organization = organization;
        fetch(`${REACT_APP_API_ENDPOINT}/associates`, {
          method: 'UPDATE',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `JWTToken ${usr.token}`,
          },
          body: JSON.stringify(args.data),
        })
          .then((response) => response.json())
          .then(() => {
            // The added/edited data will be saved in the Grid
            // The default edit operation is cancelled
          })
          .catch(() => {
            dialogClick('na', 'Associate Action', 'An error has occured during Update!', null);
            args.cancel = true;
          });
      }
    } else if (args.requestType === 'delete') {
      if (args.data) {
        // Here you can send the updated data to your server using AJAX call
        fetch(`${REACT_APP_API_ENDPOINT}/associates`, {
          method: 'DELETE',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `JWTToken ${usr.token}`,
          },
          body: JSON.stringify(args.data),
        })
          .then((response) => response.json())
          .then(() => {
            // The added/edited data will be saved in the Grid
            // The default edit operation is cancelled
            dialogClick('na', 'Associate Action', 'Removed!', null);
          })
          .catch(() => {
            dialogClick('na', 'Associate Action', 'An error has occured during Removal!', null);
            args.cancel = true;
          });
      }
    }
  };
  const jobActionComplete = (args) => {
    /** Set initial Focus */
    if (args.requestType === 'beginEdit') {
      args.form.elements.namedItem('title').focus();
      // eslint-disable-next-line prefer-destructuring
      const dialog = args.dialog;
      if (dialog) {
        dialog.header = `Details of ${args.rowData.title}`;
        // Customize the footer buttons
        dialog.buttons = [
          {
            buttonModel: { content: 'Save', cssClass: 'e-primary e-custom-save-button' },
            click: () => {
              // Implement your custom save logic here
              // For example, trigger the default update action:
              jobsGrid.current.endEdit();
              dialog.hide(); // Hide the dialog after saving
            },
          },
          {
            buttonModel: { content: 'Cancel', cssClass: 'e-danger' },
            click: () => {
              jobsGrid.current.closeEdit(); // Cancel the edit operation
              dialog.hide();
            },
          },
        ];

        // Mobile-specific adjustments (example)
        if (isMobile) { // Assuming 768px as a breakpoint for mobile
          dialog.width = '90%'; // Make dialog wider on mobile
          // Further adjust button styles if needed using CSS classes
        }
      }
    }
    if (args.requestType === 'save' && args.form && args.action === 'add') {
      if (args && args.data && args.data.title && args.data.title.length > 0) {
        // The default edit operation is cancelled
        // Here you can send the updated data to your server using AJAX call
        if (!args.data.organizationid || args.data.organizationid.length === 0) {
          args.data.organizationid = organizationid;
          args.data.organization = organization;
        }
        fetch(`${REACT_APP_API_ENDPOINT}/jobs`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `JWTToken ${usr.token}`,
          },
          body: JSON.stringify(args.data),
        })
          .then((response) => response.json())
          .then((responseJson) => {
            // The added/edited data will be saved in the Grid
            if (responseJson && responseJson._id) {
              args.data._id = responseJson._id;
            }
            if (responseJson && responseJson.response && responseJson.response !== 'OK') {
              args.cancel = true;
              dialogClick('na', 'Jobs Action', 'An error has occured during Insert!', null);
            } else {
              dialogClick('na', 'Jobs Action', 'Added!', null);
            }
          })
          .catch((error) => {
            args.cancel = true;
            dialogClick('na', 'Jobs Action', 'error!', null);
          });
      } else {
        args.cancel = true;
        dialogClick('na', 'Jobs Action', 'Please supply a Title for your Job!', null);
      }
    } else if (args.requestType === 'save' && args.form && args.action === 'edit') {
      if (args.data) {
        // Here you can send the updated data to your server using AJAX call
        args.data.organizationid = organizationid;
        args.data.organization = organization;
        const jobedit = [];
        jobedit.push(args.data);
        fetch(`${REACT_APP_API_ENDPOINT}/jobs`, {
          method: 'UPDATE',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `JWTToken ${usr.token}`,
          },
          body: JSON.stringify(jobedit),
        })
          .then((response) => response.json())
          .then(() => {
            // The added/edited data will be saved in the Grid
            // The default edit operation is cancelled
            dialogClick('na', 'Jobs Action', `Updated ${args.data.title}!`, null);
          })
          .catch(() => {
            dialogClick('na', 'Jobs Action error', 'An error has occured during Update!', null);
            args.cancel = true;
          });
      }
    } else if (args.requestType === 'delete') {
      if (args.data) {
        // Here you can send the updated data to your server using AJAX call
        fetch(`${REACT_APP_API_ENDPOINT}/jobs`, {
          method: 'DELETE',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `JWTToken ${usr.token}`,
          },
          body: JSON.stringify(args.data),
        })
          .then((response) => response.json())
          .then(() => {
            // The added/edited data will be saved in the Grid
            // The default edit operation is cancelled
            dialogClick('na', 'Jobs Action', 'Removed!', null);
            setFetchJob(!fetchJobs);
          })
          .catch(() => {
            dialogClick('na', 'Jobs Action', 'An error has occured during Removal!', null);
            args.cancel = true;
          });
      }
    }
  };
  const userActionComplete = (args) => {
    /** Set initial Focus */
    if (args.requestType === 'beginEdit') {
      args.form.elements.namedItem('first').focus();
      // eslint-disable-next-line prefer-destructuring
      const dialog = args.dialog;
      if (dialog) {
        dialog.header = `Details of ${args.rowData.first} ${args.rowData.last}`;
        // Customize the footer buttons
        dialog.buttons = [
          {
            buttonModel: { content: 'Save', cssClass: 'e-primary e-custom-save-button' },
            click: () => {
              // Implement your custom save logic here
              // For example, trigger the default update action:
              usersGrid.current.endEdit();
              dialog.hide(); // Hide the dialog after saving
            },
          },
          {
            buttonModel: { content: 'Cancel', cssClass: 'e-danger' },
            click: () => {
              usersGrid.current.closeEdit(); // Cancel the edit operation
              dialog.hide();
            },
          },
        ];

        // Mobile-specific adjustments (example)
        if (isMobile) { // Assuming 768px as a breakpoint for mobile
          dialog.width = '90%'; // Make dialog wider on mobile
          // Further adjust button styles if needed using CSS classes
        }
      }
    }
    if (args.requestType === 'save' && args.form && args.action === 'add') {
      if (args && args.data && args.data.first && args.data.last && args.data.first.length > 0 && args.data.email && args.data.email.length > 0) {
        // The default edit operation is cancelled
        // Here you can send the updated data to your server using AJAX call
        if (!args.data.organizationid || args.data.organizationid.length === 0) {
          args.data.organizationid = organizationid;
          args.data.organization = organization;
        }
        if (args.data.lastLogin && args.data.lastLogin === '') {
          args.data.lastLogin = '1970-01-01T00:00:00.000Z';
        }
        fetch(`${REACT_APP_API_ENDPOINT}/users`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `JWTToken ${usr.token}`,
          },
          body: JSON.stringify(args.data),
        })
          .then((response) => response.json())
          .then((responseJson) => {
            // The added/edited data will be saved in the Grid
            if (responseJson && responseJson._id) {
              args.data._id = responseJson._id;
            }
            if (responseJson && responseJson.response && responseJson.response !== 'OK') {
              dialogClick('na', 'Users Action', 'An error has occured during Insert!', null);
              args.cancel = true;
              setFetchUser(!fetchUser);
            } else {
              dialogClick('na', 'Users Action', 'Added!', null);
            }
            setFetchUser(!fetchUser);
          })
          .catch((error) => {
            dialogClick('na', 'Users Action', 'error!', null);
            args.cancel = true;
          });
      } else {
        dialogClick('na', 'Users Action', 'Please supply First, Last and a valid email address!', null);
        args.cancel = true;
      }
    } else if (args.requestType === 'save' && args.form && args.action === 'edit') {
      if (args.data) {
        // Here you can send the updated data to your server using AJAX call
        args.data.organizationid = organizationid;
        args.data.organization = organization;
        if (args.data.lastLogin && args.data.lastLogin === '') {
          args.data.lastLogin = '1970-01-01T00:00:00.000Z';
        }
        fetch(`${REACT_APP_API_ENDPOINT}/users`, {
          method: 'UPDATE',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `JWTToken ${usr.token}`,
          },
          body: JSON.stringify(args.data),
        })
          .then((response) => response.json())
          .then(() => {
            // The added/edited data will be saved in the Grid
            // The default edit operation is cancelled
            dialogClick('na', 'Users Action', `Updated ${args.data.first}!`, null);
          })
          .catch(() => {
            dialogClick('na', 'Users Action', 'An error has occured during Update!', null);
            args.cancel = true;
          });
      }
    } else if (args.requestType === 'delete') {
      if (args.data) {
        // Here you can send the updated data to your server using AJAX call
        fetch(`${REACT_APP_API_ENDPOINT}/users`, {
          method: 'DELETE',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `JWTToken ${usr.token}`,
          },
          body: JSON.stringify(args.data),
        })
          .then((response) => response.json())
          .then(() => {
            // The added/edited data will be saved in the Grid
            // The default edit operation is cancelled
            dialogClick('na', 'Users Action', 'Removed!', null);
            setFetchUser(!fetchUser);
          })
          .catch(() => {
            dialogClick('na', 'Users Action', 'An error has occured during Removal!', null);
            args.cancel = true;
          });
      }
    }
  };

  const contentOrgs = () => (
    <div id="selectAssociate">
      <div className="wizard-title">Add SubOrganization or Edit Existing</div>
      <div className="row">
        <div className="col-xs-6 col-sm-6 col-lg-6 col-md-6 search-item">
          <DropDownListComponent
            ref={
              startPoint
            }
            width="auto"
            dataSource={organizations}
            fields={autoCompleteFields}
            placeholder="Select Parent Organization"
            value={organizationid}
            enabled={crudOrgUpdate}
            readonly={!crudOrgUpdate}
            onChange={(v) => {
              setOrganizationId(v.value);
              // setOrganization(v.target.itemData.title);
            }}
            floatLabelType="Auto"
          />
        </div>
        <div className="e-adaptive-demo e-bigger">
          <div className="e-mobile-layout">
            <div className="e-mobile-content">
              <GridComponent
                ref={organizationGrid}
                toolbar={toolbarOptions}
                editSettings={isMobile ? editingMobile : editingOrg}
                rowSelected={organizationSelected}
                dataSource={organizations}
                allowSelection
                dataBound={orgDataBound}
                actionComplete={orgActionComplete}
                allowPaging
                pageSettings={{ pageSize: 5, pageCount: 5 }}
                enableAdaptiveUI={isMobile}
                rowRenderingMode={zRenderMode}
                enableAltRow
              >
                <ColumnsDirective>
                  <ColumnDirective
                    field="_id"
                    headerText="ID"
                    visible={false}
                    isPrimaryKey
                  />
                  <ColumnDirective
                    field="desc"
                    headerText="Location"
                    width="150"
                    visible
                    textAlign="Left"
                    type="text"
                  />
                  <ColumnDirective
                    field="title"
                    headerText="Title"
                    width={120}
                    validationRules={validRules}
                    type="text"
                  />
                  <ColumnDirective
                    field="address"
                    headerText="Address"
                    width="80"
                    textAlign="Left"
                    type="text"
                    visible
                  />
                  <ColumnDirective
                    field="city"
                    headerText="City"
                    width="140"
                    textAlign="Left"
                    visible
                    type="text"
                  />
                  <ColumnDirective
                    field="state"
                    headerText="State"
                    width="150"
                    visible
                    textAlign="Left"
                    type="text"
                  />
                  <ColumnDirective
                    field="zip"
                    headerText="Zip Code"
                    width="150"
                    visible
                    textAlign="Left"
                    type="text"
                  />
                </ColumnsDirective>
                <Inject services={[Page, Edit, Toolbar, ForeignKey]} />
              </GridComponent>
            </div>
          </div>
        </div>
        <br />
        <div className="btn-container">
          <button
            id="searchNext"
            className="e-btn"
            type="button"
            onClick={btnClicked}
          >
            Next
          </button>
        </div>
        <span ref={err_1} />
      </div>
    </div>
  );
  const contentAssociates = () => (
    <div id="selectAssociate">
      <div className="wizard-title">{data.associates && data.associates.length > 0 ? 'Modify existing or Add New Associate' : 'Add Associates'} </div>
      <div className="e-adaptive-demo e-bigger">
        <div className="e-mobile-layout">
          <div className="e-mobile-content">

            <GridComponent
              ref={associateGrid}
              toolbar={toolbarOptions}
              editSettings={isMobile ? editingMobile : editingAssociate}
              rowSelected={associateSelected}
              dataSource={associates}
              actionComplete={assocActionComplete}
              allowPaging
              allowSelection
              pageSettings={{ pageSize: 5, pageCount: 5 }}
              enableAdaptiveUI={isMobile}
              rowRenderingMode={zRenderMode}
              enableAltRow
            >
              <ColumnsDirective>
                <ColumnDirective
                  field="_id"
                  headerText="ID"
                  visible={false}
                  isPrimaryKey
                />
                <ColumnDirective
                  field="name"
                  headerText="Name"
                  width={120}
                  type="text"
                  validationRules={validRules}
                />
                <ColumnDirective
                  field="device"
                  headerText="Select Arm Band"
                  width="120"
                  textAlign="Left"
                  editType="dropdownedit"
                  visible
                  foreignKeyField="device"
                  foreignKeyValue="bandId"
                  dataSource={armbands}
                  template={bandTemplateGrid}
                />

                <ColumnDirective
                  field="managers"
                  headerText="Managers"
                  textAlign="Left"
                  width="120"
                  clipMode="EllipsisWithTooltip"
                  visible
                  editTemplate={mgrGrid}
                  template={mgrTemplateGrid}
                />
                <ColumnDirective
                  field="alertBundle"
                  headerText="Alert Bundle"
                  width="80"
                  clipMode="EllipsisWithTooltip"
                  textAlign="Left"
                  visible
                  editTemplate={bundleGrid}
                  template={bundleTemplateGrid}
                />
                <ColumnDirective
                  field="jobtask"
                  headerText="Job Task"
                  width="140"
                  textAlign="Left"
                  visible
                  editTemplate={jobTaskGrid}
                  template={jobTaskTemplateGrid}
                />
                <ColumnDirective
                  field="language"
                  headerText="Language"
                  width="150"
                  visible
                  textAlign="Left"
                  editTemplate={langGrid}
                  template={langTemplateGrid}
                />

              </ColumnsDirective>
              <Inject services={[Page, Edit, Toolbar, ForeignKey]} />
            </GridComponent>
          </div>
        </div>
      </div>
      <br />
      <div className="btn-container">
        <button
          id="searchNext"
          className="e-btn"
          type="button"
          onClick={btnClicked}
        >
          Back
        </button>
        <button
          id="addJobs"
          className="e-btn"
          type="button"
          onClick={btnClicked}
        >
          Continue
        </button>
      </div>
      <span ref={err_2} />
    </div>
  );
  const contentManagers = () => (
    <div id="selectManager">
      <div className="wizard-title">{managers && managers.length > 0 ? 'Modify existing or Add New Manager' : 'Add Managers'} </div>
      <div className="e-adaptive-demo e-bigger">
        <div className="e-mobile-layout">
          <div className="e-mobile-content">
            <GridComponent
              ref={managerGrid}
              toolbar={toolbarOptions}
              editSettings={isMobile ? editingMobile : editingMgr}
              rowSelected={managerSelected}
              dataSource={managers}
              actionComplete={managerActionComplete}
              allowPaging
              allowSelection
              pageSettings={{ pageSize: 5, pageCount: 5 }}
              enableAdaptiveUI={isMobile}
              rowRenderingMode={zRenderMode}
              enableAltRow
              enableStickyHeader={!isMobile}
            >
              <ColumnsDirective>
                <ColumnDirective
                  field="_id"
                  headerText="ID"
                  visible={false}
                  isPrimaryKey
                />
                <ColumnDirective
                  field="first"
                  headerText="First"
                  width={120}
                  type="text"
                />
                <ColumnDirective
                  field="last"
                  headerText="Last"
                  textAlign="Left"
                  width="120"
                  clipMode="EllipsisWithTooltip"
                  visible
                  type="text"
                />
                <ColumnDirective
                  field="language"
                  headerText="Language"
                  width="150"
                  visible
                  textAlign="Left"
                  editTemplate={langGrid}
                  template={langMgrTemplateGrid} // For display mode
                />
              </ColumnsDirective>
              <Inject services={[Page, Edit, Toolbar, ForeignKey]} />
            </GridComponent>
          </div>
        </div>
      </div>
      <br />
      <div className="btn-container">
        <button
          id="goToManagers"
          className="e-btn"
          type="button"
          onClick={btnClicked}
        >
          Back
        </button>
        <button
          id="associateNext"
          className="e-btn"
          type="button"
          onClick={btnClicked}
        >
          Continue
        </button>
      </div>
      <span ref={err_2} />
    </div>
  );
  const contentJobs = () => (
    <div id="selectJob">
      <div className="wizard-title">{jobs && jobs.length > 0 ? 'Modify existing or Add New Job' : 'Add Job'} </div>
      <div className="e-adaptive-demo e-bigger">
        <div className="e-mobile-layout">
          <div className="e-mobile-content">

            <GridComponent
              ref={jobsGrid}
              width="100%"
              toolbar={toolbarOptions}
              editSettings={isMobile ? editingMobile : editingJob}
              rowSelected={jobSelected}
              dataSource={jobs}
              actionComplete={jobActionComplete}
              allowPaging
              allowSelection
              pageSettings={{ pageSize: 5, pageCount: 5 }}
              enableAdaptiveUI={isMobile}
              rowRenderingMode={zRenderMode}
              enableAltRow
            >
              <ColumnsDirective>
                <ColumnDirective
                  field="_id"
                  headerText="ID"
                  visible={false}
                  isPrimaryKey
                />
                <ColumnDirective
                  field="title"
                  headerText="Title"
                  width={120}
                  validationRules={validRules}
                  type="text"
                />
                <ColumnDirective
                  field="status"
                  headerText="Status"
                  width="80"
                  textAlign="Left"
                  editType="dropdownedit"
                  visible
                  foreignKeyField="id"
                  foreignKeyValue="text"
                  validationRules={validRules}
                  dataSource={statuses}
                />
                <ColumnDirective
                  field="description"
                  headerText="Description"
                  width="140"
                  textAlign="Left"
                  visible
                  type="text"
                />
              </ColumnsDirective>
              <Inject services={[Page, Edit, Toolbar, ForeignKey]} />
            </GridComponent>
          </div>
        </div>
      </div>
      <br />
      <div className="btn-container">
        <button
          id="goBackToAssociates"
          className="e-btn"
          type="button"
          onClick={btnClicked}
        >
          Back
        </button>
        <button
          id="addUsers"
          type="button"
          className="e-btn"
          onClick={btnClicked}
        >
          Continue
        </button>
      </div>

      <span ref={err_3} />
    </div>
  );

  const contentDashboard = () => (
    <div id="details">
      <Heartbeat props={selectedAssociate} />
      <br />
      <div className="btn-container">
        <button
          id="goBackToAssociates"
          className="e-btn"
          type="button"
          onClick={btnClicked}
        >
          Back
        </button>
      </div>
      <span ref={err_3} />
    </div>
  );

  const contentUsers = () => (
    <div id="selectUser">
      <div className="wizard-title">{users && users.length > 0 ? 'Modify existing or Add New User' : 'Add User'} </div>
      <div className="e-adaptive-demo e-bigger">
        <div className="e-mobile-layout">
          <div className="e-mobile-content">

            <GridComponent
              ref={usersGrid}
              width="100%"
              toolbar={toolbarOptions}
              editSettings={isMobile ? editingMobile : editingUser}
              rowSelected={userSelected}
              dataSource={users}
              actionComplete={userActionComplete}
              allowPaging
              pageSettings={{ pageSize: 5, pageCount: 5 }}
              allowSelection
              enableAdaptiveUI={isMobile}
              rowRenderingMode={zRenderMode}
              enableAltRow
            >
              <ColumnsDirective>
                <ColumnDirective
                  field="_id"
                  headerText="ID"
                  visible={false}
                  isPrimaryKey
                />
                <ColumnDirective
                  field="first"
                  headerText="First Name"
                  width={120}
                  type="text"
                  validationRules={validRules}
                />
                <ColumnDirective
                  field="last"
                  headerText="Last Name"
                  width={120}
                  type="text"
                />
                <ColumnDirective
                  field="email"
                  headerText="Email Address"
                  width={120}
                  type="email"
                  validationRules={validRules}
                />
                <ColumnDirective
                  field="role"
                  headerText="Role"
                  width="80"
                  textAlign="Left"
                  editType="dropdownedit"
                  visible
                  foreignKeyField="_id"
                  foreignKeyValue="name"
                  dataSource={roles}
                />
                <ColumnDirective
                  field="mobile"
                  headerText="Mobile Number"
                  width="140"
                  textAlign="Left"
                  visible
                  type="text"
                />
              </ColumnsDirective>
              <Inject services={[Page, Edit, Toolbar, ForeignKey]} />
            </GridComponent>
          </div>
        </div>
      </div>
      <br />
      <div className="btn-container">
        <button
          id="goBackToJobs"
          className="e-btn"
          type="button"
          onClick={btnClicked}
        >
          Back
        </button>
        <button
          id="makePayment"
          className="e-btn"
          type="button"
          onClick={btnClicked}
        >
          Finish
        </button>
      </div>
    </div>
  );
  /*
    <th colspan="2">${riskLevel}</th><tr><td class="biometricsgrn"><sup class="supsm">hr</sup>${props.data.heartrate && props.data.heartrate.reading ? props.data.heartrate.reading : ''}<sub class="supsm">bpm</sub>${hrflag}<sup class="supsm">(${bhr})</sup></td><td class="biometricsltgrn">
      <sup class="supsm">hrv</sup>${props.data.hrv && props.data.hrv.reading ? props.data.hrv.reading : ''}<sub class="supsm">ms</sub>${hrvflag}<sup class="supsm">(${bhrv})</sup></td></tr><tr><td class="biometricsorn"><sub class="supsm">O<sup  class="supsm">2</sup></sub>${props.data.oxygen && props.data.oxygen.reading ? props.data.oxygen.reading : ''}<sub class="supsm">%</sub>${oflag}<sup class="supsm">(${boxy})</sup></td><td class="biometricsylw"><sup class="supsm">temp</sup>${props.data.temperature && props.data.temperature.reading ? props.data.temperature.reading : ''}<sub class="supsm">°F</sub>${tflag}<sup class="supsm">(${btemp})</sup></td></tr><tr><td class="biometricsblue"><sup class="supsm">hyd</sup>${props.data.hydration && props.data.hydration.reading ? props.data.hydration.reading : ''}<sub class="supsm">%</sub>${hflag}<sup class="supsm">(${bhyd})</sup></td><td class="biometricsblue"><sup class="supsm">rr</sup>${props.data.respiratory && props.data.respiratory.reading ? props.data.respiratory.reading : ''}<sub class="supsm">b/m</sub>${rrflag}<sup class="supsm">(${brr})</sup></td></tr></tbody></table>`;
  */
  const [crudAssociateUpdate, setCrudAssociateUpdate] = useState(false);
  const [crudAssociateCreate, setCrudAssociateCreate] = useState(false);
  const [crudAssociateDelete, setCrudAssociateDelete] = useState(false);
  const [crudAssociateRead, setCrudAssociateRead] = useState(false);
  const [crudOrgUpdate, setCrudOrgUpdate] = useState(false);
  const [crudOrgCreate, setCrudOrgCreate] = useState(false);
  const [crudOrgDelete, setCrudOrgDelete] = useState(false);
  const [crudOrgRead, setCrudOrgRead] = useState(false);
  const [crudMgrUpdate, setCrudMgrUpdate] = useState(false);
  const [crudMgrCreate, setCrudMgrCreate] = useState(false);
  const [crudMgrDelete, setCrudMgrDelete] = useState(false);
  const [crudMgrRead, setCrudMgrRead] = useState(false);
  const [crudJobUpdate, setCrudJobUpdate] = useState(false);
  const [crudJobCreate, setCrudJobCreate] = useState(false);
  const [crudJobDelete, setCrudJobDelete] = useState(false);
  const [crudJobRead, setCrudJobRead] = useState(false);
  const [crudUserUpdate, setCrudUserUpdate] = useState(false);
  const [crudUserCreate, setCrudUserCreate] = useState(false);
  const [crudUserDelete, setCrudUserDelete] = useState(false);
  const [crudUserRead, setCrudUserRead] = useState(false);

  useEffect(() => {
    if (data && data.role) {
      // Associates
      if (data.role && data.role.associates && data.role.associates.permissions.includes('Create')) {
        setCrudAssociateCreate(true);
      }
      if (data.role && data.role.associates && data.role.associates.permissions.includes('Read')) {
        setCrudAssociateRead(true);
      }
      if (data.role && data.role.associates && data.role.associates.permissions.includes('Update')) {
        setCrudAssociateUpdate(true);
      }
      if (data.role && data.role.associates && data.role.associates.permissions.includes('Delete')) {
        setCrudAssociateDelete(true);
      }

      // Organization
      if (data.role && data.role.organizations && data.role.organizations.permissions.includes('Create')) {
        setCrudOrgCreate(true);
      }
      if (data.role && data.role.organizations && data.role.organizations.permissions.includes('Read')) {
        setCrudOrgRead(true);
      }
      if (data.role && data.role.organizations && data.role.organizations.permissions.includes('Update')) {
        setCrudOrgUpdate(true);
      }
      if (data.role && data.role.organizations && data.role.organizations.permissions.includes('Delete')) {
        setCrudOrgDelete(true);
      }
      // Users
      if (data.role && data.role.users && data.role.users.permissions.includes('Create')) {
        setCrudUserCreate(true);
      }
      if (data.role && data.role.users && data.role.users.permissions.includes('Read')) {
        setCrudUserRead(true);
      }
      if (data.role && data.role.users && data.role.users.permissions.includes('Update')) {
        setCrudUserUpdate(true);
      }
      if (data.role && data.role.users && data.role.users.permissions.includes('Delete')) {
        setCrudUserDelete(true);
      }

      // Managers
      if (data.role && data.role.associates && data.role.associates.permissions.includes('Create') && data.role.associates.permissions.includes('Manager')) {
        setCrudMgrCreate(true);
      }
      if (data.role && data.role.associates && data.role.associates.permissions.includes('Read') && data.role.associates.permissions.includes('Manager')) {
        setCrudMgrRead(true);
      }
      if (data.role && data.role.associates && data.role.associates.permissions.includes('Update') && data.role.associates.permissions.includes('Manager')) {
        setCrudMgrUpdate(true);
      }
      if (data.role && data.role.associates && data.role.associates.permissions.includes('Delete') && data.role.associates.permissions.includes('Manager')) {
        setCrudMgrDelete(true);
      }
      // Jobs
      if (data.role && data.role.organizations && data.role.organizations.permissions.includes('Jobs')) {
        setCrudJobCreate(crudOrgCreate && true);
        setCrudJobRead(crudOrgRead && true);
        setCrudJobUpdate(crudOrgUpdate && true);
        setCrudJobDelete(crudOrgDelete && true);
      }
    }
  }, [data]);

  const editingOrg = {
    allowEditing: crudOrgUpdate,
    allowAdding: crudOrgCreate,
    allowDeleting: crudOrgDelete,
    allowEditOnDblClick: true,
    mode: 'Dialog',
    // For custom dialog template:
    // editMode: 'dialogtemplate',
    // dialogTemplate: '#customDialogTemplate'
  };
  const editingAssociate = {
    allowEditing: crudAssociateUpdate,
    allowAdding: crudAssociateCreate,
    allowDeleting: crudAssociateDelete,
    allowEditOnDblClick: true,
    mode: 'Dialog',
    // For custom dialog template:
    // editMode: 'dialogtemplate',
    // dialogTemplate: '#customDialogTemplate'
  };
  const editingMgr = {
    allowEditing: crudMgrUpdate,
    allowAdding: crudMgrCreate,
    allowDeleting: crudMgrDelete,
    allowEditOnDblClick: true,
    mode: 'Dialog',
    // For custom dialog template:
    // editMode: 'dialogtemplate',
    // dialogTemplate: '#customDialogTemplate'
  };
  const editingJob = {
    allowEditing: crudJobUpdate,
    allowAdding: crudJobCreate,
    allowDeleting: crudJobDelete,
    allowEditOnDblClick: true,
    mode: 'Dialog',
    // For custom dialog template:
    // editMode: 'dialogtemplate',
    // dialogTemplate: '#customDialogTemplate'
  };
  const editingUser = {
    allowEditing: crudUserUpdate,
    allowAdding: crudUserCreate,
    allowDeleting: crudUserDelete,
    allowEditOnDblClick: true,
    mode: 'Dialog',
    // For custom dialog template:
    // editMode: 'dialogtemplate',
    // dialogTemplate: '#customDialogTemplate'
  };
  const editingMobile = {
    allowEditing: false,
    allowAdding: false,
    allowDeleting: false,
    allowEditOnDblClick: false,
    mode: 'Dialog',
    // For custom dialog template:
    // editMode: 'dialogtemplate',
    // dialogTemplate: '#customDialogTemplate'
  };
  const onDialogOpen = (args) => {
    args.cancel = true;
  };
  const searchClick = (e) => {
    const searchValue = e.value;
    let searchQuery = new Query();
    if (searchValue !== '') {
      searchQuery = new Query().search(searchValue, ['Id', 'associate.name'], 'contains', true);
    }
    kanbanObj.query = searchQuery;
  };
  const reset = () => {
    textBoxObj.value = '';
    kanbanObj.query = new Query();
  };
  const contentRiskRC = () => (
    <ReportCard dt={{ associates, triage: false }} />
  );
  const contentRisk = () => (
    <div>
      <TextBoxComponent
        placeholder="Search..."
        ref={(obj) => { textBoxObj = obj; }}
        width="30%"
        change={searchClick}
      />
      <ButtonComponent type="button" id="reset" className="e-btn e-small e-outline e-warning" onClick={reset}>Reset</ButtonComponent>

      <KanbanComponent
        cssClass="kanban-overview"
        id="kanban"
        keyField="status"
        dataSource={risks}
        // dialogSettings={{ fields, className: 'e-dialog-delete' }}
        allowDragAndDrop={false}
        enablePersistence={false}
        // queryCellInfo={queryCellInfo}
        dialogOpen={onDialogOpen} // Attach the event handler here
        ref={(kanban) => { kanbanObj = kanban; }}
        cardSettings={{
          headerField: 'organizationid',
          selectionType: 'None',
          contentField: 'organization',
          template: cardTemplate,
        }}
        sortSettings={{ sortBy: 'Custom', field: Number('associate.risk'), direction: 'Descending' }}
      >
        <ColumnsDirective>
          <ColumnDirective
            headerText="HYPO"
            keyField="hypo"
            template={columnTemplate}
            allowToggle
            showAddButton={false}
          />
          <ColumnDirective
            headerText="BASELINE"
            keyField="baseline"
            template={columnTemplate}
            allowToggle
            showAddButton={false}
          />
          <ColumnDirective
            headerText="MODERATE"
            keyField="moderate"
            template={columnTemplate}
            allowToggle
            showAddButton={false}
          />
          <ColumnDirective
            headerText="ELEVATED"
            keyField="elevated"
            template={columnTemplate}
            allowToggle
            showAddButton={false}
          />
          <ColumnDirective
            headerText="SEVERE"
            keyField="severe"
            template={columnTemplate}
            allowToggle
            showAddButton={false}
          />
          <ColumnDirective
            headerText="NON REPORTING"
            keyField="nonreporting"
            template={columnTemplate}
            allowToggle
            isExpanded={false}
            showAddButton={false}
          />
        </ColumnsDirective>
      </KanbanComponent>
    </div>
  );
  const content33 = () => (
    <div>
      {associates.map((item) => (
        <div>
          <br />
          <table style={{ width: '480px', backgroundColor: 'black', color: 'white' }} className="zackat-divsquare">
            <tbody>
              <tr className="e-row">
                {
                  item.risk === '' ? <><th><font color="blue">HYPO</font></th><th className="monacocyan"><font color="green">BASELINE</font></th><th><font color="yellow">MODERATE</font></th><th><font color="orange">ELEVATED</font></th><th><font color="red">SEVERE</font></th></>
                    : item.risk < 0 ? <><th className="monacocyan"><font color="blue">HYPO</font></th><th><font color="green">BASELINE</font></th><th><font color="yellow">MODERATE</font></th><th><font color="orange">ELEVATED</font></th><th><font color="red">SEVERE</font></th></>
                      : item.risk < 25 ? <><th><font color="blue">HYPO</font></th><th className="monacocyan"><font color="green">BASELINE</font></th><th><font color="yellow">MODERATE</font></th><th><font color="orange">ELEVATED</font></th><th><font color="red">SEVERE</font></th></>
                        : item.risk < 50 ? <><th><font color="blue">HYPO</font></th><th><font color="green">BASELINE</font></th><th className="monacocyan"><font color="yellow">MODERATE</font></th><th><font color="orange">ELEVATED</font></th><th><font color="red">SEVERE</font></th></>
                          : item.risk < 80 ? <><th><font color="blue">HYPO</font></th><th><font color="green">BASELINE</font></th><th><font color="yellow">MODERATE</font></th><th className="monacocyan"><font color="orange">ELEVATED</font></th><th><font color="red">SEVERE</font></th></>
                            : item.risk !== '' ? <><th><font color="blue">HYPO</font></th><th><font color="green">BASELINE</font></th><th><font color="yellow">MODERATE</font></th><th><font color="orange">ELEVATED</font></th><th className="monacocyan"><font color="red">SEVERE</font></th></>
                              : ''
                }
              </tr>
              <tr className="e-row" title="Biometrics">
                <td colSpan="3">{item.name.toUpperCase()}<br />{item.device}</td>
                <td>MSN: 4983-013</td>
                <td>Battery: 100%</td>
              </tr>
              <tr>
                <td>{item.temperature && item.temperature.reading}°F<br />Core Temp</td>
                <td>88<sub>bpm</sub><br />Heart Rate</td>
                <td>92%<br />Hydration</td>
                <td>98%<br />O<sup>2</sup></td>
                <td>{item.latlng && item.latlng.latitude}, {item.latlng.longitude}<br />Location</td>
              </tr>
            </tbody>
          </table>
          <br />
        </div>
      ))}
    </div>
  );
  //          to="https://scribehow.com/viewer/Onboarding_process__CRv1dFBlSLi9irpw_4463g?referrer=workspace"

  return (
    <div className="m-2 md:m-1 mt-2 p-1 md:p-4 bg-white rounded-3xl zackat-divalh">
      <div className="flex">
        <Link
          className="my-link"
          to="/pdf/onboarding.pdf"
          target="_blank"
        >
          <img src={scribeHow} width={20} height={20} />
        </Link>
        <Header category="Administration" title={organization === '' ? '--Onboarding--' : `--Onboarding-- ${organization}`} />
      </div>
      <div className="col-lg-12 control-section e-tab-section">
        {/* EXPLANATORY OVERLAY */}
        {showOverlay && showGotItOrg !== 'false' && (
          <div className="wizard-overlay-container">
            <div className="wizard-instruction-modal">
              <div className="wizard-instruction-modal-inner zackat-divalh">
                <h2>Welcome to the Wizard!</h2>
                <p>Welcome to the Zackat Labs (sensocore) onboarding process.</p>
                <p>This screen represents the Organization setup process, on this page you will see your initial Organization that was created for you by your Zackat Labs Sales team.</p>
                <p>On this page, you may create additional child Organizations to meet your company model.</p>
                <ul style={{ textAlign: 'center', marginBottom: '20px' }}>
                  <li>Fill out the mandatory fields.</li>
                  <li>Click NEXT to activate the next tab.</li>
                  <li>Click BACK to return the previous tab.</li>
                  <li>Complete all steps to finalize your submission.</li>
                </ul>
                <div>
                  <ButtonComponent
                    iconCss="e-icons e-assistview-icon"
                    cssClass="custom-padding-btn"
                    onClick={() => setShowOverlay(false)}
                  >
                    Start Wizard
                  </ButtonComponent>
                  <ButtonComponent
                    iconCss="e-icons e-check"
                    onClick={() => { localStorage.setItem('gotItOrg', 'false'); setShowGotItOrg('false'); }}
                  >
                    Got It
                  </ButtonComponent>
                </div>
              </div>
            </div>
          </div>
        )}
        {/* EXPLANATORY OVERLAY */}
        {tab && tab.current && tab.current.selectedItem === 1 && showMgr && showGotItMgr !== 'false' && (
        <div className="wizard-overlay-container">
          <div className="wizard-instruction-modal">
            <div className="wizard-instruction-modal-inner zackat-divalh">
              <p>This screen represents the Manager setup process, Managers are the persons responsible for monitoring the Organization`s Associates.</p>
              <p>On this page, you may create Manager to meet your company model.</p>
              <ul style={{ textAlign: 'center', marginBottom: '20px' }}>
                <li>Fill out the mandatory fields.</li>
                <li>Click CONTINUE to activate the next tab.</li>
                <li>Click BACK to return the previous tab.</li>
                <li>Complete all steps to finalize your submission.</li>
              </ul>
              <div>
                <ButtonComponent
                  iconCss="e-icons e-assistview-icon"
                  cssClass="custom-padding-btn"
                  onClick={() => setShowMgr(false)}
                >
                  Dismiss
                </ButtonComponent>
                <ButtonComponent
                  iconCss="e-icons e-check"
                  onClick={() => { localStorage.setItem('gotItMgr', 'false'); setShowGotItMgr('false'); }}
                >
                  Got It
                </ButtonComponent>
              </div>
            </div>
          </div>
        </div>
        )}
        {/* EXPLANATORY OVERLAY */}
        {tab && tab.current && tab.current.selectedItem === 2 && showAssociates && showGotItAssociates !== 'false' && (
        <div className="wizard-overlay-container">
          <div className="wizard-instruction-modal">
            <div className="wizard-instruction-modal-inner zackat-divalh">
              <p>This screen represents the Associate setup process, Associates are the field personnel wearing the W3 monitoring armband.</p>
              <p>On this page, you may create Associates to meet your company model.</p>
              <ul style={{ textAlign: 'center', marginBottom: '20px' }}>
                <li>Fill out the mandatory fields.</li>
                <li>Click CONTINUE to activate the next tab.</li>
                <li>Click BACK to return the previous tab.</li>
                <li>Complete all steps to finalize your submission.</li>
              </ul>
              <div>
                <ButtonComponent
                  iconCss="e-icons e-assistview-icon"
                  cssClass="custom-padding-btn"
                  onClick={() => setShowAssociates(false)}
                >
                  Dismiss
                </ButtonComponent>
                <ButtonComponent
                  iconCss="e-icons e-check"
                  onClick={() => { localStorage.setItem('gotItAssociates', 'false'); setShowGotItAssociates('false'); }}
                >
                  Got It
                </ButtonComponent>
              </div>
            </div>
          </div>
        </div>
        )}
        {/* EXPLANATORY OVERLAY */}
        {tab && tab.current && tab.current.selectedItem === 3 && showJobs && showGotItJobs !== 'false' && (
        <div className="wizard-overlay-container">
          <div className="wizard-instruction-modal">
            <div className="wizard-instruction-modal-inner zackat-divalh">
              <p>This screen represents the Job setup process, Jobs represent the geographical locations where the field personnel wil be working while wearing the W3 monitoring armband.</p>
              <p>On this page, you may create Jobs to meet your company model.</p>
              <ul style={{ textAlign: 'center', marginBottom: '20px' }}>
                <li>Fill out the mandatory fields.</li>
                <li>Click CONTINUE to activate the next tab.</li>
                <li>Click BACK to return the previous tab.</li>
                <li>Complete all steps to finalize your submission.</li>
              </ul>
              <div>
                <ButtonComponent
                  iconCss="e-icons e-assistview-icon"
                  cssClass="custom-padding-btn"
                  onClick={() => setShowJobs(false)}
                >
                  Dismiss
                </ButtonComponent>
                <ButtonComponent
                  iconCss="e-icons e-check"
                  onClick={() => { localStorage.setItem('gotItJobs', 'false'); setShowGotItJobs('false'); }}
                >
                  Got It
                </ButtonComponent>
              </div>
            </div>
          </div>
        </div>
        )}
        {/* EXPLANATORY OVERLAY */}
        {tab && tab.current && tab.current.selectedItem === 4 && showUsers && showGotItUsers !== 'false' && (
        <div className="wizard-overlay-container">
          <div className="wizard-instruction-modal">
            <div className="wizard-instruction-modal-inner zackat-divalh">
              <p>This screen represents the User setup process, Users are the people who administer your W3 Dashboard (Users are perople just like you) that are reponsible for setting up Managers, Associates, Jobs, Users and other aspects of the this dashboard.</p>
              <p>On this page, you may create Users to meet your company model.</p>
              <ul style={{ textAlign: 'center', marginBottom: '20px' }}>
                <li>Fill out the mandatory fields.</li>
                <li>Click CONTINUE to activate the next tab.</li>
                <li>Click BACK to return the previous tab.</li>
                <li>Complete all steps to finalize your submission.</li>
              </ul>
              <div>
                <ButtonComponent
                  iconCss="e-icons e-assistview-icon"
                  cssClass="custom-padding-btn"
                  onClick={() => setShowUsers(false)}
                >
                  Dismiss
                </ButtonComponent>
                <ButtonComponent
                  iconCss="e-icons e-check"
                  onClick={() => { localStorage.setItem('gotItUsers', 'false'); setShowGotItUsers('false'); }}
                >
                  Got It
                </ButtonComponent>
              </div>
            </div>
          </div>
        </div>
        )}

        <div className="e-sample-resize-container">
          <TabComponent
            id="tab-wizard"
            ref={tab}
            heightAdjustMode="None"
            height="auto"
            selecting={tabSelected}
            overflowMode="Scrollable"
          >
            <TabItemsDirective>
              <TabItemDirective
                header={headerText[0]}
                content={contentOrgs}
              />
              <TabItemDirective
                header={headerText[1]}
                content={contentManagers}
                disabled
              />
              <TabItemDirective
                header={headerText[2]}
                content={contentAssociates}
                disabled
              />
              <TabItemDirective
                header={headerText[3]}
                content={contentJobs}
                disabled
              />
              <TabItemDirective
                header={headerText[4]}
                content={contentUsers}
                disabled
              />
              <TabItemDirective
                header={headerText[5]}
                content={contentRiskRC}
                disabled={associates && associates.length === 0}
              />
              <TabItemDirective
                header={headerText[6]}
                content={contentDashboard}
                disabled={enableContent}
              />
            </TabItemsDirective>
          </TabComponent>
          <DialogComponent
            ref={alertDlg}
            header="Success"
            width={250}
            isModal
            visible={false}
            showCloseIcon
            content="Onboarding successfully completed<br />You will now be presented with the full complement of Menu Items and Actions that have been assigned to particular user role. You can use these menu items and features to further refine the system parameters, add, update, or remove entries on the system. You may, if you choose, return to the Onboarding wizard to add additional Managers, Users, and/or Associates as well as create additional sub-organizations to match your requirements."
            target={dlgTarget}
            buttons={dlgButtons}
            created={dlgCreated}
          />
          {!hideDialog && (
            <DialogComponent
              header={header}
              content={taskTemplate}
              buttons={addbuttons}
              width="35%"
              height="40%"
              isModal
              visible
              closeOnEscape
              showCloseIcon
              onClose={() => { setDialog(!hideDialog); }}
              close={() => { setDialog(!hideDialog); }}
            />
          )}
        </div>
      </div>
    </div>
  );
};
export default Onboarding;
